import React from "react";
import { connect } from "react-redux";
import { Header } from "../../components";
import Footer from "../../components/Footer/Footer";
import "./_LandingPage.scss";
import ProductSelectLink from "../../components/ProductSelectLink/ProductSelectLink";
const DISABLE_NECKLACE = process.env.REACT_APP_DISABLE_NECKLACE;

class LandingPage extends React.Component {
  render() {
    const {
      pageTitleText,
      necklaceTitleText,
      necklaceDescriptionText,
      ringTitleText,
      ringDescriptionText,
      necklaceImageURL,
      ringImageURL,
      ringImageExplodedURL,
      selectButtonText,
    } = this.props;
    let necklacePath = "/?view=collection-necklace";
    if (DISABLE_NECKLACE) {
      necklacePath = null;
    }

    return (
      <div className="landing-page ojl-configurator-page">
        <Header titleText={pageTitleText} />
        <div className="selections">
          <ProductSelectLink
            titleText={ringTitleText}
            linkPath="/?view=collection"
            imageURL={ringImageURL}
            imageExplodedURL={ringImageExplodedURL}
            richText={ringDescriptionText}
            buttonText={selectButtonText}
          />
          {DISABLE_NECKLACE ? null : (
            <>
              <div className="vertical-splitter"></div>
              <ProductSelectLink
                titleText={necklaceTitleText}
                imageURL={necklaceImageURL}
                imageExplodedURL={necklaceImageURL}
                richText={necklaceDescriptionText}
                linkPath={necklacePath}
                buttonText={selectButtonText}
              />
            </>
          )}
        </div>
        <Footer backButtonText="takaisin" forwardButtonText="eteenpäin" />
      </div>
    );
  }
}

const mapStateToProps = ({ landingPage }) => {
  const {
    pageTitleText,
    necklaceTitleText,
    ringDescriptionText,
    ringTitleText,
    necklaceImageURL,
    ringImageURL,
    ringImageExplodedURL,
    selectButtonText,
    necklaceDescriptionText,
  } = landingPage;

  return {
    pageTitleText,
    necklaceTitleText,
    ringDescriptionText,
    ringTitleText,
    necklaceImageURL,
    ringImageURL,
    ringImageExplodedURL,
    selectButtonText,
    necklaceDescriptionText,
  };
};

export default connect(mapStateToProps, {})(LandingPage);
